var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.928 22.72h6.507c1.365 0 2.229-.693 2.229-1.963v-2.666H8.331v1.642h3.498v.694c0 .442-.24.56-.533.56H5.301c-.437 0-.576-.224-.576-.576v-2.88c0-.384.219-.534.454-.534h8.485v-1.706H4.912a1.88 1.88 0 00-2.059 2.042v3.355a1.877 1.877 0 002.075 2.032zM16.683 17.083l2.991 5.637h1.734l2.986-5.637v5.637h1.883v-7.43h-2.89l-2.843 5.334-2.854-5.333h-2.88v7.43h1.873v-5.638zM27.36 17.333v3.355a1.878 1.878 0 002.075 2.032h7.84v-1.872h-7.467c-.437 0-.576-.224-.576-.57v-2.609c0-.384.213-.533.454-.533h7.589v-1.845h-7.856a1.88 1.88 0 00-2.059 2.042z"
  })));
}
export default SvgGmc;